/**
* @file 系统设置-费用中心
* */
<template>
  <div id="cost">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="续费账户" name="1">
        <!-- 续费账户 -->
        <div id="renewal">
          <div class="box-line">
            <span class="title-text">账户余额</span>
            <span class="title-left">¥ {{ balance.toFixed(2) }}</span>
          </div>
          <div class="box-line">
            <span class="title-text">余额充值</span>
            <div class="input">
              <el-input v-model="form.input" size="mini" placeholder="请输入正确金额，支持2位小数" minlength="1"></el-input>
            </div>
            <span class="title-text" style="margin-right: 20px">元</span>
            <el-button type="primary" @click="TopUpAmountClick()">立即充值</el-button>
            <div class="logo-box">
              <img src="../../../assets/img/zfb.png" alt="" />
              <span class="text-box">支付宝在线充值</span>
            </div>
          </div>

          <div class="box-line">
            <span class="title-text">账单明细</span>
            <div class="prompt">
              <div style="margin-bottom: 7px">
                <span style="margin-right: 5px">*</span>
                <span>每月1日可查看上个月账单</span>
              </div>
              <div>
                <span style="margin-right: 5px">*</span>
                <span>因余额不足导致扣费失败，系统将停机/暂停使用</span>
              </div>
            </div>
            <div style="font-size: 14px">
              <span>应付合计：</span>
              <span class="combined">￥{{ payCombined.toFixed(2) }} </span>
              <span style="margin-left: 20px">扣费时间：</span>
              <span>{{ deductionPageTime || nextTime }}</span>
            </div>
          </div>

          <el-table border :data="renewalList" stripe empty-text="暂无数据" max-height="420px" v-loading="loading"
            style="width: 100%">
            <el-table-column label="对账日期" v-slot="scope">
              <span v-show="scope.row.status == 0">{{ year1 }}/{{
                month3 >= 10 ? month3 : "0" + month3
              }}/01&nbsp;-&nbsp;
              </span>
              <span v-show="scope.row.status == 0">{{ year1 }}/{{ month3 >= 10 ? month3 : "0" + month3 }}/30
              </span>
              <span v-show="scope.row.status !== 0">{{ scope.row.startTime | filterTime('YYYY/MM/DD') }}
                &nbsp;-&nbsp;</span>
              <span v-show="scope.row.status !== 0">{{
                scope.row.endTime | filterTime('YYYY/MM/DD')
              }}</span>
            </el-table-column>
            <el-table-column label="完成订单" v-slot="scope">
              <span>{{
                scope.row.finishOrderNum !== 0 ? scope.row.finishOrderNum : "-"
              }}</span>
            </el-table-column>
            <el-table-column label="成交金额（GMV）" v-slot="scope">
              <span>{{
                scope.row.totalRealFee !== 0
                ? "¥" + scope.row.totalRealFee.toFixed(2)
                : "-"
              }}</span>
            </el-table-column>
            <el-table-column label="佣金比例" v-slot="scope">
              <span>{{
                scope.row.ratio !== 0 ? scope.row.ratio + "%" : "-"
              }}</span>
            </el-table-column>
            <el-table-column label="应付服务费" v-slot="scope">
              <span>
                {{
                  scope.row.serviceFee !== null
                  ? "¥" + scope.row.serviceFee.toFixed(2)
                  : "-"
                }}</span>
            </el-table-column>
            <el-table-column label="状态" v-slot="scope">
              <span v-show="scope.row.status == 1" style="color: #ff0000">待扣费</span>
              <span v-show="scope.row.status == 0" style="color: #999999">统计中</span>
            </el-table-column>
          </el-table>

          <el-pagination style="float: right" @size-change="sizeChange" @current-change="pageChange"
            :current-page="pagination.page" :page-sizes="[20, 30, 40, 60]" :page-size="pagination.size"
            layout="total, sizes, jumper,prev, pager, next" :total="pagination.total">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="历史账单" name="2">
        <!-- 历史账单 -->
        <div id="history">
          <el-table border :data="historyList" stripe max-height="500px" empty-text="暂无数据" v-loading="loading"
            style="width: 100%">
            <el-table-column label="对账日期" v-slot="scope">
              <span>{{ scope.row.startTime | filterTime('YYYY/MM/DD') }}&nbsp;-&nbsp;</span>
              <span>{{ scope.row.endTime | filterTime('YYYY/MM/DD') }}</span>
            </el-table-column>
            <el-table-column label="完成订单" v-slot="scope">
              <span>{{
                scope.row.finishOrderNum ? scope.row.finishOrderNum : "-"
              }}</span>
            </el-table-column>
            <el-table-column label="成交金额（GMV）" v-slot="scope">
              <span>¥ {{ scope.row.totalRealFee != null ? scope.row.totalRealFee.toFixed(2) : '0.00' }}</span>
            </el-table-column>
            <el-table-column label="佣金比例" v-slot="scope">
              <span>{{ scope.row.ratio }}%</span>
            </el-table-column>
            <el-table-column label="应付服务费" v-slot="scope">
              <span>
                ¥
                {{
                  scope.row.serviceFee != null && scope.row.serviceFee !== 0
                  ? scope.row.serviceFee.toFixed(2)
                  : "0.00"
                }}</span>
            </el-table-column>
            <el-table-column label="状态" v-slot="scope">
              <span v-show="scope.row.status == 2" style="color: #009900">已扣费</span>
            </el-table-column>
          </el-table>

          <div style="margin-top: 10px">
            <el-pagination style="float: right" @size-change="sizeChangeHistory" @current-change="pageChangeHistory"
              :current-page="paginationHistory.page" :page-sizes="[20, 30, 40, 60]" :page-size="paginationHistory.size"
              layout="total, sizes, jumper,prev, pager, next" :total="paginationHistory.total">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="收支明细" name="3">
        <!-- 收支明细 -->
        <div id="detail">
          <div class="box">
            <span style="margin-right: 10px">
              <el-select v-model="detailValue" size="mini" clearable @change="searchClick">
                <el-option v-for="val in detailArr" :key="val.id" :value="val.id" :label="val.name">
                </el-option>
              </el-select>
            </span>
            <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始时间"
              end-placeholder="结束时间" value-format="timestamp" @change="timeClick" clearable size="mini">
            </el-date-picker>
          </div>
          <el-table border :data="detailList" stripe max-height="500px" empty-text="暂无数据" v-loading="loading"
            style="width: 100%">
            <el-table-column prop="created" label="交易时间" v-slot="scope">
              <span>{{ scope.row.created | filterTime('YYYY/MM/DD HH:mm:SS') }}</span>
            </el-table-column>
            <el-table-column prop="transactionType" label="交易类型" v-slot="scope">
              <span v-show="scope.row.transactionType === 1">账单扣费</span>
              <span v-show="scope.row.transactionType === 2">客户充值</span>
              <span v-show="scope.row.transactionType === 3">系统代充</span>
            </el-table-column>
            <el-table-column prop="amount" label="金额" v-slot="scope">
              <span style="font-weight: bold" v-show="scope.row.transactionType === 1">- ¥{{ scope.row.amount.toFixed(2)
              }}</span>
              <span style="color: #ff9900; font-weight: bold" v-show="scope.row.transactionType === 2">+¥{{
                scope.row.amount.toFixed(2) }}</span>
              <span style="color: #ff9900; font-weight: bold" v-show="scope.row.transactionType === 3">+¥{{
                scope.row.amount.toFixed(2) }}</span>
            </el-table-column>
            <el-table-column label="余额" v-slot="scope">
              <span>¥ {{ scope.row.balance.toFixed(2) }}</span>
            </el-table-column>
            <el-table-column prop="remark" label="备注" v-slot="scope">
              <el-button @click="dialogClick(scope.row)" type="text"
                v-show="scope.row.transactionType === 1">查看账单</el-button>
              <span v-show="scope.row.transactionType !== 1">{{ scope.row.remark }}</span>
            </el-table-column>
          </el-table>

          <div style="margin-top: 10px">
            <el-pagination style="float: right" @size-change="sizeChangeDetail" @current-change="pageChangeDetail"
              :current-page="paginationDetail.page" :page-sizes="[20, 30, 40, 60]" :page-size="paginationDetail.size"
              layout="total, sizes, jumper,prev, pager, next" :total="paginationDetail.total">
            </el-pagination>
          </div>

          <el-dialog :title="'【' + institutions + '】' + '的账单明细'" :visible.sync="dialogVisible" width="70%"
            :before-close="handleClose">
            <div style="margin: 10px 0 20px 0">
              <span class="dialog-text">合计：</span>
              <span class="dialog-text">￥{{ combined.toFixed(2) }} </span>
              <span class="dialog-text" style="margin-left: 20px">扣费时间：</span>
              <span class="dialog-text">{{ deductionTime | filterTime('YYYY/MM/DD HH:mm:SS') }}</span>
            </div>
            <div>
              <el-table :data="dialogList" stripe empty-text="暂无数据" max-height="430px" v-loading="loading"
                style="width: 100%">
                <el-table-column label="对账日期" v-slot="scope">
                  <span>{{ scope.row.startTime | filterTime('YYYY/MM/DD') }} &nbsp;-&nbsp;</span>
                  <span>{{ scope.row.endTime | filterTime('YYYY/MM/DD') }}</span>
                </el-table-column>
                <el-table-column prop="finishOrder" label="完成订单" v-slot="scope">
                  <span>{{
                    scope.row.finishOrderNum ? scope.row.finishOrderNum : "-"
                  }}</span>
                </el-table-column>
                <el-table-column label="成交金额（GMV）" v-slot="scope">
                  <span>¥ &nbsp;{{ scope.row.totalRealFee.toFixed(2) }}</span>
                </el-table-column>
                <el-table-column label="佣金比例" v-slot="scope">
                  <span>{{ scope.row.ratio }}%</span>
                </el-table-column>
                <el-table-column label="应付服务费" v-slot="scope">
                  <span>
                    ¥
                    {{
                      scope.row.serviceFee !== 0
                      ? scope.row.serviceFee.toFixed(2)
                      : "0.00"
                    }}</span>
                </el-table-column>
              </el-table>
            </div>
            <div class="paging">
              <el-pagination style="float: right" @size-change="sizeChangeDialog" @current-change="pageChangeDialog"
                :current-page="paginationDialog.page" :page-sizes="[20, 30, 40, 60]" :page-size="paginationDialog.size"
                layout="total, sizes, jumper,prev, pager, next" :total="paginationDialog.total">
              </el-pagination>
            </div>
          </el-dialog>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="充值" width="30%" :visible.sync="codeVisible" :before-close="dialogClose" :append-to-body="true"
      class="rich">
      <div class="qrcode" id="qrcode">
        <span>请使用 支付宝 扫码充值</span>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="codeVisibleClose" size="mini" type="primary">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import QRCode from "../../../assets/js/qrcode.min.js";
export default {
  name: "cost",
  data() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth();
    let day = date.getDate();
    return {
      codeVisible: false,
      qrCode: null,
      timer: null,
      activeName: "1", //tabs默认选择
      form: {
        input: null,
      },
      tableData: [
        {
          startTime: "",
          endTime: "",
          finishOrderNum: 0,
          totalRealFee: 0,
          ratio: 0,
          serviceFee: null,
          status: 0,
        },
      ],
      pagination: {
        page: 1,
        size: 20,
        total: 0,
      },
      paginationHistory: {
        page: 1,
        size: 20,
        total: 0,
      },
      paginationDetail: {
        page: 1,
        size: 20,
        total: 0,
      },
      paginationDialog: {
        page: 1,
        size: 20,
        total: 0,
      },
      time: "",
      loading: false,
      dialogVisible: false, //弹窗是否显示
      detailValue: "", //下拉框默认值
      detailArr: [
        {
          id: "",
          name: "全部",
        },
        {
          id: 1,
          name: "账单扣费",
        },
        {
          id: 2,
          name: "客户充值",
        },
        {
          id: 3,
          name: "系统代充",
        },
      ],
      renewalList: [], //续费列表数据
      historyList: [], //历史账单列表数据
      detailList: [], //收支明细列表数据
      dialogList: [], //弹窗数据列表
      balance: 0, //账户余额
      payCombined: 0, //应付合计
      combined: 0, //合计
      institutions: "", //机构名称
      year1: year,
      month1: month + 2,
      month3: month + 1,
      deductionTime: null, //扣费时间
      day: day,
      type: null, //状态
      Id: null, //扣费账单ID
      start: "", //开始时间
      end: "", //结束时间
      deductionPageTime: null,
    };
  },
  computed: {
    nextTime() {
      let date = new Date();
      return date.getDate() < 5
        ? `${date.getFullYear()}-${date.getMonth() + 1}-05 00:00:00`
        : `${date.getMonth() + 2 > 12
          ? date.getFullYear() + 1
          : date.getFullYear()
        }-${date.getMonth() + 2 > 12 ? "1" : date.getMonth() + 2
        }-05 00:00:00`;
    },
  },
  async created() {
    this.getRenewalList();
    this.getBalance();
    this.getTimeFn()
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    async getTimeFn() {
      const {code, data} = await this.$axios.get("/api/v1/manage/systems/costCenter/config/deductTime")
      if (code === 1 && data.deductionTime) {
        this.deductionPageTime = this.$utils.timeFn(data.deductionTime, "YYYY-MM-DD HH:mm:SS")
      }

    },
    //查看账单详情
    dialogClick(row) {
      this.Id = row.id;
      this.deductionTime = row.created;
      this.getDialogList(this.Id);
      this.institutions = "";
      this.combined = 0;
      this.getPlatformName(this.Id);
      this.dialogVisible = true;
    },
    //立即充值
    async TopUpAmountClick() {
      if (
        this.form.input === null ||
        this.form.input === undefined ||
        this.form.input === ""
      ) {
        this.$message.warning("请输入充值金额");
      } else if (!/^(\d{1,8}.?\d{0,2}|0.\d?[1-9]?)$/.test(this.form.input)) {
        this.$message.warning(
          "充值金额请输入非0或非负数,最大不能超过八位数,且最多包含两位小数！"
        );
      } else if (this.form.input > 99999999.99) {
        this.$message.warning("充值金额最大不能超过八位数！");
      } else {
        let data = await this.$axios.post("/api/v1/pay/recharge", {
          amount: this.form.input,
        });

        if (data.code == 1) {
          this.codeVisible = true;
          this.$nextTick(() => {
            if (this.qrCode) {
              this.qrCode.makeCode(data.data.qrCode);
            } else {
              this.qrCode = new QRCode(document.getElementById("qrcode"), {
                text: data.data.qrCode,
                width: 200,
                height: 200,
              });
            }
          });

          let numS = 0;
          this.timer = setInterval(async () => {
            numS += 5;
            if (numS >= 300) {
              clearInterval(this.timer);
              if (this.qrCode) { this.qrCode.clear(); }
              this.codeVisible = false;
              this.$message.warning("二维码已过期，请重新充值");
              return;
            }
            let res = await this.$axios.get("/api/v1/pay/recharge/status", {
              outTradeNo: data.data.outTradeNo,
            });
            if (res?.data?.status == 2) {
              clearInterval(this.timer);
              if (this.qrCode) { this.qrCode.clear(); }
              this.form.input = null;
              this.codeVisible = false;
              this.$message.success("充值成功");
              this.getRenewalList();
              this.getBalance();
            }
          }, 5000);
        }
      }
    },
    codeVisibleClose() {
      if (this.qrCode) { this.qrCode.clear(); }
      if (this.timer) { clearInterval(this.timer); }
      this.codeVisible = false;
    },
    dialogClose() {
      if (this.qrCode) { this.qrCode.clear(); }
      if (this.timer) { clearInterval(this.timer); }
      this.codeVisible = false;
    },
    //获取续费列表数据
    async getRenewalList() {
      this.loading = true;
      let url = "/api/v1/manage/systems/costCenter/billList";
      let params = {
        page: this.pagination.page,
        size: this.pagination.size,
        status: 1,
      };
      let res = await this.$axios.get(url, params);
      if (res && res.code === 1) {
        this.renewalList = res.data || [];
        this.pagination.total = res.total;
      }
      this.tableData.forEach((item) => {
        this.renewalList.unshift(item);
      });
      this.loading = false;
    },
    //获取弹窗列表数据
    async getDialogList(id) {
      this.loading = true;
      let url = "/api/v1/manage/systems/costCenter/billList";
      let params = {
        page: this.paginationDialog.page,
        size: this.paginationDialog.size,
        status: 2,
        flowingId: id,
      };
      let res = await this.$axios.get(url, params);
      if (res && res.code === 1) {
        this.dialogList = res.data || [];
        this.paginationDialog.total = res.total;
      }
      this.loading = false;
    },
    //获取历史账单列表数据
    async getHistoryList() {
      this.loading = true;
      let url = "/api/v1/manage/systems/costCenter/billList";
      let params = {
        page: this.paginationHistory.page,
        size: this.paginationHistory.size,
        status: 2,
      };
      let res = await this.$axios.get(url, params);
      if (res && res.code === 1) {
        this.historyList = res.data || [];
        this.paginationHistory.total = res.total;
      }
      this.loading = false;
    },
    //获取收支明细列表数据
    async getDetailList(type, start, end) {
      this.loading = true;
      let url = "/api/v1/manage/systems/costCenter/paymentDetailsList";
      let params = {
        page: this.paginationDetail.page,
        size: this.paginationDetail.size,
        transactionType: type,
        startTime: start,
        endTime: end,
      };
      let res = await this.$axios.get(url, params);
      if (res && res.code === 1) {
        this.detailList = res.data || [];
        this.paginationDetail.total = res.total;
      }
      this.loading = false;
    },
    //获取账户余额
    async getBalance() {
      let url = "/api/v1/manage/systems/costCenter/platformAccountBalance";
      let res = await this.$axios.get(url);
      if (res && res.code === 1) {
        this.balance = res.data?.accountBalance || 0;
        this.payCombined = res.data?.summationFee || 0;
      }
    },
    //获取机构名称
    async getPlatformName(id) {
      let url = "/api/v1/manage/systems/costCenter/platformBillDetail";
      let params = {
        flowingId: id,
      };
      let res = await this.$axios.get(url, params);
      if (res && res.code === 1) {
        this.combined = res.data?.totalFee || 0;
        this.institutions = res.data?.platformName || "";
      }
    },

    //下拉框搜索
    searchClick(val) {
      this.getDetailList(val);
      //清空时间选择器
      this.start = "";
      this.end = "";
      this.time = "";
    },
    //时间选择器
    timeClick(val) {
      if (val != null) {
        this.start = val[0] / 1000;
        this.end = val[1] / 1000 + 86399;
        this.getDetailList("", this.start, this.end);
      } else {
        this.getDetailList();
      }
      //清空下拉选择
      this.detailValue = "";
    },
    //tabs被选中是触发
    handleClick() {
      if (this.activeName == 1) {
        this.getRenewalList();
        this.getBalance();
      } else if (this.activeName == 2) {
        this.getHistoryList();
      } else {
        this.getDetailList();
      }
    },
    // 续费账户分页
    sizeChange(size) {
      this.pagination.size = size;
      this.getRenewalList();
      this.getBalance();
    },
    pageChange(page) {
      this.pagination.page = page;
      this.getRenewalList();
      this.getBalance();
    },
    // 历史账单分页
    sizeChangeHistory(size) {
      this.paginationHistory.size = size;
      this.getHistoryList();
    },
    pageChangeHistory(page) {
      this.paginationHistory.page = page;
      this.getHistoryList();
    },
    // 收支明细分页
    sizeChangeDetail(size) {
      this.paginationDetail.size = size;
      this.getDetailList();
    },
    pageChangeDetail(page) {
      this.paginationDetail.page = page;
      this.getDetailList();
    },
    // 收支明细弹窗分页
    sizeChangeDialog(size) {
      this.paginationDialog.size = size;
      this.getDialogList(this.Id);
    },
    pageChangeDialog(page) {
      this.paginationDialog.page = page;
      this.getDialogList(this.Id);
    },
    // 关闭弹窗
    handleClose() {
      this.institutions = "";
      this.combined = 0;
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="less" scope>
#cost {
  #renewal {
    .logo-box {
      margin: 5px 0 5px 82px;
      display: flex;
      align-items: center;

      img {
        width: 20px;
        height: 20px;
        border-radius: 50%;
      }

      .text-box {
        margin-left: 10px;
        color: #999999;
      }
    }

    .el-form {
      margin-bottom: 20px !important;
    }

    .input {
      margin-left: 25px;
      width: 240px;
      display: inline-block;
      margin-right: 5px;
    }

    .el-pagination {
      padding: 15px 5px !important;
    }

    .box-line {
      margin: 20px 0;
    }

    .title-text {
      font-size: 14px;
      font-weight: bold;
      color: #000000;
    }

    .prompt {
      margin: 10px 0 20px 0;
      padding: 10px;
      background-color: #f2f2f2;
    }

    .combined {
      color: #ff9900;
      font-weight: bold;
    }

    .title-left {
      font-size: 14px;
      margin-left: 25px;
    }
  }

  #detail {
    .dialog-text {
      font-size: 16px;
    }

    .box {
      margin: 20px 0;
    }

    .paging {
      height: 30px;
      margin-top: 10px;
    }
  }
}

.qrcode {
  width: 200px;
  margin: auto;
  text-align: center;

  img {
    margin: 20px 0;
  }
}
</style>
